import { t } from "@/i18n-js/instance";
import { formatFileSize } from "@/react/helpers/fileSizeHelpers";
import { useBillingContext } from "../BillingContext";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.storage";

export const StorageUsageDetails = () => {
  const { auxiliarySubscription } = useBillingContext();
  const storage = auxiliarySubscription?.storage;

  if (!storage || !storage.extra_storage) {
    return null;
  }

  const {
    total_bytes_used,
    total_capacity_bytes,
    usage_percentage,
    formatted_price,
    has_addon: hasAddon,
    extra_storage,
  } = storage;

  const descriptionKey = hasAddon
    ? `${localeRoot}.limit.description_with_addon`
    : `${localeRoot}.limit.description`;

  const description = t(descriptionKey, {
    used: formatFileSize(total_bytes_used),
    total: formatFileSize(total_capacity_bytes),
    addon: formatFileSize(extra_storage.purchased_storage_bytes),
  });

  return (
    <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
      <UsageMetric
        title={t(`${localeRoot}.limit.title`)}
        progress={usage_percentage}
        description={description}
        price={formatted_price ?? ""}
      />
    </UsageDetailsSection>
  );
};
